import React, { useState } from 'react';
import Header from './navbar.js';
import { Link, useNavigate } from 'react-router-dom';
import '../css/resetPassword.css';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../store/Slices/authSlice.js';
import { encryptData } from '../helpers/encryptData.js';
import toast, { Toaster } from 'react-hot-toast';
import LoadingScreen from '../skeletons/loadingSkeleton.jsx';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const loading = useSelector((state) => state.auth.loading);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setError('');
    };

    const handleEmailBlur = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email) && email.length > 0) {
            setError('Invalid email format');
        } else {
            setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            setError('Email is required');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(email)) {
            setError('Invalid email format');
            return;
        }

        const publicKey = localStorage.getItem('publicKey');

        if (!publicKey) {
            setError('Unable to process request. Please try again.');
            return;
        }

        const data = {
            email: encryptData(email, publicKey)
        };

        dispatch(forgotPassword(data)).then((response) => {
            if (response?.payload?.message) {
                setSubmitted(true);
                toast.success('Please check your email');
            } else {
                setError(
                    response?.error?.message ||
                    'Something went wrong. Please try again.'
                );
            }
        });
    };

    return (
        <div>
            <Header />

            <Toaster
                position="top-center"
                reverseOrder={false}
            />

            {loading ? (
                <LoadingScreen />
            ) : (
                <div className="reset-password-container">

                    {!submitted ? (
                        <form
                            onSubmit={handleSubmit}
                            className="reset-password-box"
                        >
                            <div>
                                <h1
                                    style={{
                                        color: '#f16e00',
                                        fontWeight: 'bold',
                                        fontSize: '22px'
                                    }}
                                >
                                    Forgot Password
                                </h1>
                                <br />
                            </div>

                            <div>
                                <label>Email:</label>

                                <input
                                    type="email"
                                    value={email}
                                    onChange={handleEmailChange}
                                    onBlur={handleEmailBlur}
                                    placeholder="Example@orange.com"
                                />

                                {error && (
                                    <span>{error}</span>
                                )}
                            </div>

                            <div className="login-link">
                                <Link to="/">
                                    Back to Login
                                </Link>
                            </div>

                            <button type="submit">
                                Send Reset Link
                            </button>
                        </form>
                    ) : (
                        <div className="reset-password-box">
                            <h1
                                style={{
                                    color: '#f16e00',
                                    fontWeight: 'bold'
                                }}
                            >
                                Check Your Email
                            </h1>

                            <p>
                                If an account exists for this email,
                                a password reset link has been sent.
                            </p>

                            <p>
                                Please check your inbox and follow
                                the link to reset your password.
                            </p>

                            <div className="login-link">
                                <Link to="/">
                                    Back to Login
                                </Link>
                            </div>
                        </div>
                    )}

                </div>
            )}
        </div>
    );
};

export default ForgotPassword;